import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AdressClientModel } from '../../../../core/models/address.model'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { ProfileTypeService } from '../../../../core/services/contact/contact-type/contact-type.service'
import { ContactService } from '../../../../core/services/contact/contact/contact.service'
import { NgxMaskDirective } from 'ngx-mask'
import {MatSlideToggle} from '@angular/material/slide-toggle';
@Component({
  selector: 'contact-patient-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    NgxMaskDirective,
    MatSlideToggle,
  ],
  templateUrl: './contact-client-edit-form.component.html',
  styleUrl: './contact-client-edit-form.component.scss',
  providers: [ProfileTypeService, ContactService],
  standalone: true,
})
export class ContactClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private contactTypeService: ProfileTypeService,
    private contactService: ContactService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId: number = 0

  listType: any[] = []

  ngOnInit(): void {
    //this.getListType()
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  // getListType() {
  //   this.contactTypeService.listContactType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('name')?.setValue(this.editItem.data.nome)
    this.form.get('typeContact')?.setValue(this.editItem.data.parentesco)
    this.form.get('phone')?.setValue(this.editItem.data.telefone?.slice(2))
    this.form.get('email')?.setValue(this.editItem.data.email)
    this.form.get('active')?.setValue(this.editItem.data.enviar_email === '1' || this.editItem.data.enviar_email === 1)
  }

  resetForm() {
    this.form.reset()
    this.form.get('active')?.setValue(true)
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      typeContact: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: [''],
      active: [true],
    })
  }
  createContact() {
    this.loading = true
    const model = this.createModel()
    this.contactService.createContact(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.contactService.editContact(this.editItem.data.id,model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        nome: this.form.controls['name'].value,
        parentesco: this.form.controls['typeContact'].value,
        telefone: '55'+this.form.controls['phone'].value,
        email: this.form.controls['email'].value,
        enviar_email: this.form.controls['active'].value,
      }
    } else {
      return {
        paciente_id: this.personId,
        nome: this.form.controls['name'].value,
        parentesco: this.form.controls['typeContact'].value,
        telefone: '55'+this.form.controls['phone'].value,
        email: this.form.controls['email'].value,
        enviar_email: this.form.controls['active'].value,
      }
    }
  }
}
